/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  // 変数 ========== common
	  var windowBreakPoint = 768;
	  var windowDefaultWidth = window.innerWidth; // 変数 ========== slider
	
	  var sliderBg = document.getElementById('sliderBg'); // 変数 ========== header
	
	  var headerLogo = document.getElementById('headerLogo');
	  var headerLogoImg = document.getElementById('headerLogoImg');
	  var headerNav = document.getElementById('headerNav');
	  var headerNavFlag = false;
	  var headerBtnOpen = document.getElementById('headerBtnOpen');
	  var headerBtnClose = document.getElementById('headerBtnClose'); // let blurTargetDefault = document.querySelector('.idx-main_bg');
	  // 変数 ========== footer
	
	  var footerBtnCorporate = document.getElementById('footerBtnCorporate');
	  var footerBtnRecruit = document.getElementById('footerBtnRecruit'); // 関数 ========== HoverChangeImg
	
	  var HoverChangeImg = function HoverChangeImg(changeTarget, changeSrc, baseSrc) {
	    function AddImgOpacity() {
	      changeTarget.className = 'item-anchor_img-opacity';
	    }
	
	    function RemoveImgOpacity() {
	      changeTarget.className = '';
	    }
	
	    function ChangeImgOver() {
	      changeTarget.setAttribute('src', changeSrc);
	    }
	
	    ;
	
	    function ChangeImgLeave() {
	      changeTarget.setAttribute('src', baseSrc);
	    }
	
	    ;
	    changeTarget.addEventListener('mouseover', function () {
	      setTimeout(AddImgOpacity, 0);
	      setTimeout(ChangeImgOver, 295);
	      setTimeout(RemoveImgOpacity, 300);
	    }, false);
	    changeTarget.addEventListener('mouseleave', function () {
	      setTimeout(AddImgOpacity, 0);
	      setTimeout(ChangeImgLeave, 295);
	      setTimeout(RemoveImgOpacity, 300);
	    }, false);
	  };
	
	  window.addEventListener('load', function () {
	    if (windowDefaultWidth > windowBreakPoint) {
	      window.addEventListener('scroll', function () {
	        var scrollVolume = window.pageYOffset;
	
	        if (scrollVolume > 90) {
	          headerLogo.className = 'st-header_logo st-header_logo-small';
	          headerLogoImg.setAttribute('src', '/assets/images/common/img-logo-black.svg');
	          headerNav.className = 'st-header_nav st-header_nav-hidden st-header_nav-shadow';
	        } else {
	          headerLogo.className = 'st-header_logo';
	          headerNav.className = 'st-header_nav st-header_nav-hidden';
	          headerLogoImg.setAttribute('src', '/assets/images/common/img-logo-white.svg');
	        }
	      }, false); // blurTargetDefault.setAttribute('style', 'height:' + windowDefaultWidth * 0.45 + 'px');
	
	      HoverChangeImg(footerBtnCorporate, '/assets/images/pc/footer_btn-corporate-hover.png', '/assets/images/pc/footer_btn-corporate.png');
	      HoverChangeImg(footerBtnRecruit, '/assets/images/pc/footer_btn-recruit-hover.png', '/assets/images/pc/footer_btn-recruit.png');
	    } else {
	      headerBtnOpen.addEventListener('click', function () {
	        if (!headerNavFlag) {
	          headerNav.className = 'st-header_nav st-header_nav-visible';
	          headerNavFlag = true;
	        }
	      }, false);
	      headerBtnClose.addEventListener('click', function () {
	        if (headerNavFlag) {
	          headerNav.className = 'st-header_nav st-header_nav-hidden';
	          headerNavFlag = false;
	        }
	      }, false);
	    }
	  }, false);
	  window.addEventListener('resize', function () {
	    var windowResizeWidth = window.innerWidth;
	
	    if (windowResizeWidth > windowBreakPoint) {
	      window.addEventListener('scroll', function () {
	        var scrollVolume = window.pageYOffset;
	
	        if (scrollVolume > 90) {
	          headerLogo.className = 'st-header_logo st-header_logo-small';
	          headerLogoImg.setAttribute('src', '/assets/images/common/img-logo-black.svg');
	          headerNav.className = 'st-header_nav st-header_nav-hidden st-header_nav-shadow';
	        } else {
	          headerLogo.className = 'st-header_logo';
	          headerNav.className = 'st-header_nav st-header_nav-hidden';
	          headerLogoImg.setAttribute('src', '/assets/images/common/img-logo-white.svg');
	        }
	      }, false); // blurTargetDefault.setAttribute('style', 'height:' + windowResizeWidth * 0.45 + 'px');
	
	      HoverChangeImg(footerBtnCorporate, '/assets/images/pc/footer_btn-corporate-hover.png', '/assets/images/pc/footer_btn-corporate.png');
	      HoverChangeImg(footerBtnRecruit, '/assets/images/pc/footer_btn-recruit-hover.png', '/assets/images/pc/footer_btn-recruit.png');
	    } else {
	      headerBtnOpen.addEventListener('click', function () {
	        if (!headerNavFlag) {
	          headerNav.className = 'st-header_nav st-header_nav-visible';
	          headerNavFlag = true;
	        }
	      }, false);
	      headerBtnClose.addEventListener('click', function () {
	        if (headerNavFlag) {
	          headerNav.className = 'st-header_nav st-header_nav-hidden';
	          headerNavFlag = false;
	        }
	      }, false);
	    }
	  }, false); // var blurTarget = $('#blurTarget');
	  // blurTarget.backgroundBlur('../assets/images/common/main_img-visual-47heroines.png');
	  // blurTarget.backgroundBlur({
	  //   imageURL: '../assets/images/common/main_img-visual-47heroines.png',
	  //   imageClass: 'idx-main_bg-blur',
	  //   blurAmount: 4
	  // });
	  // var chromePointerEvents = typeof PointerEvent === 'function'; if (chromePointerEvents) { if (orig.pointerId === undefined) { return; } }
	  // touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig];
	
	  var sliderImages = $('.idx-main_slider_item_img');
	  var sliderImagesLength = sliderImages.length;
	  var sliderBack = [];
	
	  for (var i = 0; i < sliderImagesLength; i++) {
	    var baseImage = sliderImages.eq(i);
	    var baseText = baseImage.attr('src');
	    var fixedText = baseText.replace('/assets', './assets');
	    sliderBack.push(fixedText);
	  }
	
	  if ($(window).width() > 768) {
	    $("#sliderMain").bxSlider({
	      auto: true,
	      infiniteLoop: true,
	      responsive: true,
	      speed: 800,
	      displaySlideQty: 3,
	      pager: true,
	      slideWidth: 1200,
	      moveSlides: 1,
	      pause: 5000,
	      touchEnabled: false,
	      onSlideBefore: function onSlideBefore(e, oI, nI) {
	        sliderBg.setAttribute('style', 'background-image: url(' + sliderBack[nI] + ');');
	      }
	    });
	  } else {
	    $("#sliderMain").bxSlider({
	      auto: true,
	      infiniteLoop: true,
	      responsive: true,
	      speed: 800,
	      displaySlideQty: 3,
	      pager: true,
	      slideWidth: 1200,
	      moveSlides: 1,
	      pause: 5000,
	      touchEnabled: true,
	      onSlideBefore: function onSlideBefore(e, oI, nI) {
	        sliderBg.setAttribute('style', 'background-image: url(' + sliderBack[nI] + ');');
	      }
	    });
	  }
	
	  $(document).on('mousedown', '.bx-viewport a', function () {
	    var $this = $(this),
	        myHref = $this.attr('href'),
	        myTarget = $this.attr('target');
	
	    if (myTarget === '_blank') {
	      window.open(myHref);
	    } else {
	      window.location.href = myHref;
	    }
	  });
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 600;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkTimeWidth = $(window).width();
	    var linkDifference;
	
	    if (linkTimeWidth > 768) {
	      linkDifference = 90;
	    } else {
	      linkDifference = linkTimeWidth * 0.15625;
	    }
	
	    var linkPosition = linkTarget.offset().top - linkDifference;
	    $("html, body").animate({
	      scrollTop: linkPosition
	    }, linkSpeed, "swing");
	    return false;
	  });
	})();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js